export default __webpack_public_path__ + "static/media/frank.2859270f.ttf";